import React, { useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { linkExpenseToRecurring } from '../../api/wallet';
import { getErrorMessage } from '../../utils/errors';

// Links a single recorded expense to a recurring budget item (or unlinks it),
// so the expense feeds the annual matrix as "realizado".
const RecurringLinkSelect = ({ expense, items = [], onLinked, onError }) => {
  const current = items.find((i) => i.ID === expense.RecurringExpenseId) || null;
  const [saving, setSaving] = useState(false);

  const handleChange = async (event, newValue) => {
    const recurringId = newValue?.ID || '';
    setSaving(true);
    try {
      await linkExpenseToRecurring(expense.ID, recurringId);
      onLinked?.(expense.ID, recurringId);
    } catch (err) {
      onError?.(getErrorMessage(err, 'Falha ao vincular ao planejamento.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Autocomplete
      options={items}
      value={current}
      onChange={handleChange}
      getOptionLabel={(option) => option?.Name || ''}
      isOptionEqualToValue={(option, value) => option?.ID === value?.ID}
      size="small"
      clearText="limpar vínculo"
      disabled={saving}
      sx={{ minWidth: 160 }}
      renderInput={(params) => (
        <TextField {...params} placeholder="Item recorrente" size="small" variant="standard" />
      )}
    />
  );
};

export default RecurringLinkSelect;
